<template>
  <b-row>
    <b-col v-for="(field, i) in fieldsMapper" cols="12" class="my-2" :key="i">
      <template>
        <label :for="field.key">
          <span>{{ field.labelText }}</span>
        </label>
        <multiselect
            v-if="field.type === 'multiselect'"
            :id="field.key"
            v-model="invoiceData[field.key]"
            :class="{ required: !invoiceData[field.key] && field.required }"
            :max-height="200"
            searchable
            :options-limit="300"
            placeholder=""
            :disabled="field.disabled"
            :label="field.label"
            :track-by="field.trackBy"
            :options="field.options"/>
        <float-input
            :id="field.key"
            :class="{ required: !invoiceData[field.key] && field.required }"
            placeholder=""
            v-else-if="field.type === 'input'"
            v-model="invoiceData[field.key]"
            class="form-control"
            type="text"></float-input>
      </template>
    </b-col>
  </b-row>
</template>
<script>
import Multiselect from 'vue-multiselect'
import FloatInput from '@/components/common/FloatInput';

export default {
  name: 'FieldsMapperInvoiceCreation',
  components: {
    Multiselect,
    FloatInput
  },
  props: {
    fieldsMapper: {
      type: Array,
      default: () => []
    },
    value: {
      type: Object,
      default: () => ({})
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  data () {
    return {
      invoiceData: {
        invoice_sum: '',
        operation: null,
        contract: null
      }
    }
  },
  watch: {
    'invoiceData.operation': {
      immediate: false,
      async handler (value) {
        const operation_id = value?.id
        if (value) {
          await this.$store.cache.dispatch('contracts/loadRelatedToOperationContracts', { operation_id })
        }
      }
    },
    invoiceData: {
      deep: true,
      immediate: true,
      handler (value) {
        this.$emit('change', value)
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/common/purchase-invoices/FieldsMapperInvoiceCreation.vue